import React from 'react'

import { Formik } from 'formik'

import { 
    ValidatorForm, 
} from 'react-material-ui-form-validator'

export const FormikPadrao = props => {
    return (
        <Formik
            enableReinitialize={true}
            {...props}
        />
    )
}

export const ValidatorFormPadrao = props => {
    return (
        <ValidatorForm
            {...props}
        />
    )
}

